// extracted by mini-css-extract-plugin
export var wordContainer = "_pv-0";